"use strict";
require.context("../../images", true);
import "../../../../decidim-module-ideal/app/packs/entrypoints/decidim_ideal";
